import { mapGetters, mapMutations } from "vuex";
// import { ll02To84 } from "@/utils/map/mapToolsFun.js";
import request from "@/api/monitorCenter/map.js";
import { saveArea_Api } from "@/api/monitorCenter/logisticsMap";

// const COLOR_TITLE = "#000";
// import axios from "@/http";
// import e6BaseUrl from "@/e6GetBaseUrl.js";
var mixin = {
  data: function() {
    return {
      mLevel: "市",
      aLevel: "市",
      mEyeShow: false,
      aEyeShow: false,
      lEyeShow: false
    };
  },
  computed: {
    ...mapGetters([
      // "markerDatas",
      // "areaDatas",
      // "lineDatas",
      "isFullScreen"
    ])
  },
  methods: {
    // ...mapActions([
    //     "fetchMarkerDatasAct",
    //     "fetchAreaDatasAct",
    //     "fetchLineDatasAct",
    //     "fetchCategoryDatasAct"
    // ]),
    ...mapMutations(["updateFullScreen"]),
    // mapInitBack() {
    // 获取数据后，改变了vuex里边的markerDatas，监听了markerDatas，去更新table
    // this.fetchMarkerDatas_mixin(); // 获取标记数据
    // this.fetchAreaDatas_mixin(); // 获取区域数据
    // this.fetchLineDatas_mixin(); // 获取行数据
    // },
    // fetchMarkerDatas_mixin({ dealType = 0, params = {} } = {}) {
    //     return new Promise((resolve, reject) => {
    //         this.fetchMarkerDatasAct()
    //             .then(res => {
    //                 // 画地图
    //                 this.handle_markers({ dealType, params });
    //                 resolve(res);
    //             })
    //             .catch(err => {
    //                 reject(err);
    //             });
    //     });
    // },
    // fetchAreaDatas_mixin({ dealType = 0, params = {} } = {}) {
    //     return new Promise((resolve, reject) => {
    //         this.fetchAreaDatasAct()
    //             .then(res => {
    //                 // 画地图
    //                 this.handle_areas({ dealType, params });
    //                 resolve(res);
    //             })
    //             .catch(err => {
    //                 reject(err);
    //             });
    //     });
    // },
    // fetchLineDatas_mixin({ dealType = 0, params = {} } = {}) {
    //     return new Promise((resolve, reject) => {
    //         this.fetchLineDatasAct()
    //             .then(res => {
    //                 // 画地图
    //                 this.handle_lines({ dealType, params });
    //                 resolve(res);
    //             })
    //             .catch(err => {
    //                 reject(err);
    //             });
    //     });
    // },
    // 保存覆盖物
    saveOverlay(opts) {
      switch (opts.type) {
        case "area":
          this.saveArea(opts);
          break;
        case "areaXz":
          this.saveArea(opts);
          break;
        default:
          break;
      }
    },
    // 保存区域 -- 包括普通区域与行政区域
    async saveArea(opts) {
      let params = opts.params;
      let lnglatArr = [];
      params.llObjArr.forEach(param => {
        lnglatArr.push(`${param.lat84},${param.lng84}`);
      });
      let aParams = {
        areaId: params.id,
        areaName: params.name,
        areaCode: params.code,
        orgId: params.orgId,
        typeId: params.typeId,
        categoryId: params.categoryId,
        areaColor: params.acreageColor,
        titleColor: params.titleColor,
        areaAcreage: params.areaAcreage,
        areaLonLat: lnglatArr.join(";"),
        lonCenter: params.lng84,
        latCenter: params.lat84,
        position: params.address,
        shareMode: params.share,
        contact: params.contact,
        telephone: params.telephone,
        remark: params.remark,
        inLayer: 0
      };
      let res = await saveArea_Api(aParams);
      if (res.code == 1) {
        this.$message({
          message: "保存成功",
          type: "success"
        });
        this.$refs[this.mapName].aCloseLayer();
        this.$refs[this.mapName].aXzCloseLayer();
        // this.removeTempOverlay();
        this.fetchAreaDatas();
        // 区分是行政区域还是普通区域
        // let parentArray = [];
        // let mutationFun = null;
        // if (params.typeId == 4) {
        //   parentArray = this.xzAreaDatas;
        //   mutationFun = this.FETCH_XZ_AREA_DATAS;
        // } else {
        //   parentArray = this.areaDatas;
        //   mutationFun = this.FETCH_AREA_DATAS;
        // }
        // const index = parentArray.findIndex(a => a.areaId == res.result.areaId);
        // if (index !== -1) {
        //   parentArray[index] = Object.assign(parentArray[index], res.result);
        // } else {
        //   parentArray.unshift(res.result);
        // }
        // mutationFun({ data: [...parentArray] });
        // this.handle_areas({
        //   params: res.result,
        //   dealType: 1
        // });
      } else {
        this.$message({
          message: res.message,
          type: "warning"
        });
      }
    },
    // saveMarker(opts) { // 保存标记
    //     let params = opts.params;
    //     let sParams = {
    //         areaId: params.id,
    //         areaName: params.name,
    //         areaCode: params.code,
    //         orgId: params.orgId,
    //         categoryId: params.categoryId, // 类别
    //         areaColor: params.acreageColor,
    //         titleColor: COLOR_TITLE,
    //         areaAcreage: params.acreage,
    //         lonCenter: params.lng84,
    //         latCenter: params.lat84,
    //         imgUrl: params.icon,
    //         rangeLength: params.radius, // 范围长度
    //         position: params.address,
    //         shareMode: params.share,
    //         remark: params.remark
    //     };
    //     request.saveMarker_Api(sParams).then(res => {
    //         if (res.code == 1) {
    //             this.$message({
    //                 message: "保存成功",
    //                 type: "success"
    //             });
    //             this.$refs[this.mapName].mCloseLayer(true);
    //             this.fetchMarkerDatas_mixin({
    //                 params: Object.assign(params, {
    //                     id: res.result
    //                 }),
    //                 dealType: 1
    //             });
    //             // 防止area修改成marker，所以要重新更新area数据
    //             // 如果是area修改成marker，上句代码dealType保存后操作的时候，会调用deleteLogisOverlays删除地图上的此叠加物（marker和area都会去查找删除）
    //             if (sParams.areaId != 0) {
    //                 // 上句代码中会处理删除地图上的area，不需要处理area在地图的情况，只需要更新vuex中area数据就行
    //                 this.fetchAreaDatasAct();
    //             }
    //         } else {
    //             this.$message({
    //                 message: res.msg,
    //                 type: "error"
    //             });
    //         }
    //     });
    // },
    // saveArea(opts) {
    //     let params = opts.params;
    //     let lnglatArr = [];
    //     params.llObjArr.forEach(param => {
    //         lnglatArr.push(`${param.lat84},${param.lng84}`);
    //     });
    //     let aParams = {
    //         areaId: params.id,
    //         areaName: params.name,
    //         areaCode: params.code,
    //         orgId: params.orgId,
    //         typeId: params.typeId,
    //         categoryId: params.categoryId,
    //         areaColor: params.acreageColor,
    //         titleColor: COLOR_TITLE,
    //         areaAcreage: params.acreage,
    //         areaLonlat: lnglatArr.join(";"),
    //         lonCenter: params.lng84,
    //         latCenter: params.lat84,
    //         position: params.address,
    //         shareMode: params.share,
    //         remark: params.remark
    //     };
    //     request.saveArea_Api(aParams).then(res => {
    //         if (res.code == 1) {
    //             this.$message({
    //                 message: "保存成功",
    //                 type: "success"
    //             });
    //             this.$refs[this.mapName].aCloseLayer();
    //             this.fetchAreaDatas_mixin({
    //                 params: Object.assign(params, {
    //                     id: res.result
    //                 }),
    //                 dealType: 1
    //             });
    //             //防止marker修改成area，所以要重新更新marker数据
    //             if (sParams.fenceId != 0) {
    //                 this.fetchMarkerDatasAct();
    //             }
    //         } else {
    //             this.$message({
    //                 message: res.msg,
    //                 type: "error"
    //             });
    //         }
    //     });
    // },
    // handle_markers(opts) {
    //     let params = opts.params;
    //     switch (opts.dealType) {
    //         case 0: // 初始化后
    //             this.initLogisMarkers(); //物流地图中，将全部的点加载在地图上
    //             break;
    //         case 1: // 保存后
    //             if (params.id) {
    //                 this.$refs[this.mapName].deleteLogisOverlays([params.id]);
    //                 this.$refs[this.mapName].addLogisMarkers([
    //                     {
    //                         llObj: {
    //                             lng84: params.lng84,
    //                             lat84: params.lat84
    //                         },
    //                         icon: params.icon,
    //                         title: params.name,
    //                         extData: {
    //                             id: params.id
    //                         }
    //                     }
    //                 ]);
    //             }
    //             break;
    //         case 2: // 删除后
    //             // 处理地图上的marker相关信息
    //             this.$refs[this.mapName].deleteLogisMarkers(params.delIdArr);
    //             break;
    //         case 3: // 导入后
    //             this.$refs[this.mapName].deleteLogisMarkers();
    //             this.initLogisMarkers();
    //             break;
    //         default:
    //             break;
    //     }
    // },
    // handle_areas(opts) {
    //     let params = opts.params;
    //     switch (opts.dealType) {
    //         case 0:
    //             this.initLogisAreas(); //物流地图中，将全部的点加载在地图上
    //             break;
    //         case 1:
    //             if (params.id) {
    //                 this.$refs[this.mapName].deleteLogisOverlays([params.id]);
    //                 this.$refs[this.mapName].addLogisAreas([
    //                     {
    //                         lng84: params.lng84 || 0,
    //                         lat84: params.lat84 || 0,
    //                         lng02: params.lng02 || 0,
    //                         lat02: params.lat02 || 0,
    //                         llObjArr: params.llObjArr,
    //                         fillColor: params.acreageColor,
    //                         strokeColor: params.acreageColor,
    //                         title: params.name,
    //                         extData: {
    //                             id: params.id
    //                         }
    //                     }
    //                 ]);
    //             }
    //             break;
    //         case 2:
    //             // 处理地图上的marker相关信息
    //             this.$refs[this.mapName].deleteLogisAreas(params.delIdArr);
    //             break;
    //         case 3: // 导入后
    //             this.$refs[this.mapName].deleteLogisAreas();
    //             this.initLogisAreas();
    //             break;
    //         default:
    //             break;
    //     }
    // },
    // initLogisAreas() {
    //     let aDatasArr = [];
    //     this.areaDatas.forEach(aData => {
    //         let llObjArr = [];
    //         let aLnglatStr = aData.areaLonlat.split(";");
    //         aLnglatStr.forEach(lnglatStr => {
    //             if (lnglatStr != "") {
    //                 let llArr = lnglatStr.split(",");
    //                 llObjArr.push({ lng84: Number(llArr[1]), lat84: Number(llArr[0]) });
    //             }
    //         });
    //         let opts = {
    //             llObjArr: llObjArr,
    //             strokeColor: aData.areaColor,
    //             fillColor: aData.areaColor,
    //             label: aData.areaName,
    //             lng84: aData.lonCenter,
    //             lat84: aData.latCenter,
    //             winDetails: this.getWinInfo_area(aData),
    //             extData: {
    //                 id: aData.areaId
    //             }
    //         };
    //         aDatasArr.push(opts);
    //     });
    //     this.$refs[this.mapName].addLogisAreas(aDatasArr);
    // },
    // initLogisMarkers() {
    //     let mDatasArr = [];
    //     this.markerDatas.forEach(mData => {
    //         let opts = {
    //             llObj: {
    //                 lng84: mData.lonCenter,
    //                 lat84: mData.latCenter
    //             },
    //             icon: mData.imgUrl,
    //             label: mData.areaName,
    //             winDetails: this.getWinInfo_marker(mData),
    //             extData: {
    //                 id: mData.areaId
    //             }
    //         };
    //         mDatasArr.push(opts);
    //     });
    //     this.$refs[this.mapName].addLogisMarkers(mDatasArr);
    // },
    // saveLine(opts) {
    //     let params = opts.params;
    //     let lnglatArr = [];
    //     params.llObjArr.forEach(param => {
    //         let lng84 = param.lng84 || 0;
    //         let lat84 = param.lat84 || 0;
    //         if(!lng84 || !lat84){
    //             let llObj = ll02To84(param.lng02, param.lat02);
    //             lng84 = llObj.lng;
    //             lat84 = llObj.lat;
    //         }
    //         lnglatArr.push(`${lat84},${lng84}`);
    //     });
    //     let lParams = {
    //         lineId: params.id,
    //         lineName: params.name,
    //         lineCode: params.code,
    //         orgId: params.orgId,
    //         lineColor: params.lineColor,
    //         titleColor: COLOR_TITLE,
    //         lineWidth: params.width,
    //         bPosition: params.bposition,
    //         ePositon: params.eposition,
    //         lineOdometer: params.odometer,
    //         lineLonlat: lnglatArr.join(";"),
    //         shareMode: params.share,
    //         remark: params.remark
    //     };
    //     request.saveLine_Api(lParams).then(res => {
    //         if (res.code == 1) {
    //             this.$message({
    //                 message: "保存成功",
    //                 type: "success"
    //             });
    //             this.$refs[this.mapName].lCloseLayer();
    //             // this.curPage_line = 1;
    //             // this.requestTable_line();
    //             // // 处理地图上的area相关信息 res.data为电子围栏id
    //             // if (typeof res.data != "undefined") {
    //             //   this.$refs.aLogisMap.deleteLogisLines([res.data]);
    //             //   this.$refs.aLogisMap.addLogisLines([
    //             //     {
    //             //       llObjArr: params.llObjArr,
    //             //       strokeColor: sParams.color,
    //             //       strokeWeight: sParams.width,
    //             //       extData: {
    //             //         id: res.data
    //             //       }
    //             //     }
    //             //   ]);
    //             // }
    //             this.fetchLineDatas_mixin({
    //                 params: Object.assign(params, {
    //                     id: res.data
    //                 }),
    //                 dealType: 1 //添加
    //             });
    //         } else {
    //             this.$message({
    //                 message: res.msg,
    //                 type: "error"
    //             });
    //         }
    //     });
    // },
    // handle_lines(opts) {
    //     let params = opts.params;
    //     switch (opts.dealType) {
    //         case 0: //预留，当前未在地图上加载线路信息
    //             break;
    //         case 1:
    //             // //预留，当前未在地图上添加line信息
    //             // if (params.id) {
    //             //   this.$refs[this.mapName].deleteLogisLines([params.id]);
    //             //   this.$refs[this.mapName].addLogisLines([
    //             //     {
    //             //       llObjArr: params.llObjArr,
    //             //       strokeColor: params.color,
    //             //       strokeWeight: params.width,
    //             //       extData: {
    //             //         id: params.id
    //             //       }
    //             //     }
    //             //   ]);
    //             // }
    //             break;
    //         case 2:
    //             if (typeof params.id != "undefined") {
    //                 this.$refs[this.mapName].deleteLogisLines([params.id]);
    //             }
    //             break;
    //         default:
    //             break;
    //     }
    // },
    // eyeChange(oType, isShow) {
    //     switch (oType) {
    //         case "marker":
    //             this.mEyeShow = isShow;
    //             break;
    //         case "area":
    //             this.aEyeShow = isShow;
    //             break;
    //         case "line":
    //             this.lEyeShow = isShow;
    //             break;
    //         default:
    //             break;
    //     }
    //     let mapObjShow = 0;
    //     if (this.mEyeShow) {
    //         mapObjShow += 1;
    //     }
    //     if (this.aEyeShow) {
    //         mapObjShow += 2;
    //     }
    //     if (this.lEyeShow) {
    //         mapObjShow += 4;
    //     }
    //     // 保存
    //     request.saveOverlayShow_Api({ mapObjShow }).then(res => {
    //         if ((res.code = 1)) {
    //             this.$message({
    //                 message: "设置成功",
    //                 type: "success"
    //             });
    //             // 设置完成之后重新查询一遍
    //             this.fetchOverlaySetting();
    //         } else {
    //             this.$message({
    //                 message: res.msg,
    //                 type: "error"
    //             });
    //         }
    //     });
    // },
    // // oType：叠加物类型，marker, area
    // levelChange(oType, level) {
    //     let type = 0;
    //     switch (oType) {
    //         case "marker":
    //             type = 1;
    //             this.mLevel = level;
    //             break;
    //         case "area":
    //             type = 2;
    //             this.aLevel = level;
    //             break;
    //         default:
    //             break;
    //     }
    //     // 保存
    //     request
    //         .saveOverlayLevel_Api({
    //             type,
    //             markerLevel: level
    //         })
    //         .then(res => {
    //             if ((res.code = 1)) {
    //                 this.$message({
    //                     message: "设置成功",
    //                     type: "success"
    //                 });
    //                 // 重新查询
    //                 this.fetchOverlaySetting();
    //             } else {
    //                 this.$message({
    //                     message: res.msg,
    //                     type: "error"
    //                 });
    //             }
    //         });
    // },
    // getWinInfo_marker(oData) {
    //     let winInfo = `<div class='win-table'>
    //               <table>
    //                 <tr><td><h2>名称：</h2></td><td>${
    //         oData.areaName
    //         }</td></tr>
    //                 <tr><td><h2>面积：</h2></td><td>${
    //         oData.areaAcreage
    //         } km²</td></tr>
    //                 <tr><td><h2>自编号：</h2></td><td>${
    //         oData.areaCode
    //         }</td></tr>
    //                 <tr><td><h2>类型：</h2></td><td>${
    //         oData.typeName
    //         }</td></tr>
    //                 <tr><td><h2>所属部门：</h2></td><td>${
    //         oData.orgName
    //         }</td></tr>
    //                 <tr><td><h2>共享模式：</h2></td><td>${
    //         oData.shareModeName
    //         }</td></tr>
    //                 <tr><td><h2>半径：</h2></td><td>${
    //         oData.rangeLength
    //         } m</td></tr>
    //                 <tr><td><h2>位置：</h2></td><td>${
    //         oData.position
    //         }</td></tr>
    //                 <tr><td><h2>备注：</h2></td><td>${
    //         oData.remark
    //         }</td></tr>
    //               </table>
    //             </div>`;
    //     return winInfo;
    // },
    getWinInfo_area(oData) {
      console.log(oData);
      let winInfo = `<div class='win-table'>
                  <table>
                    <tr><td><h2>名称：</h2></td><td>${oData.areaName}</td></tr>
                    <tr><td><h2>面积：</h2></td><td>${oData.areaAcreage} km²</td></tr>
                    <tr><td><h2>自编号：</h2></td><td>${oData.areaCode}</td></tr>
                    <tr><td><h2>类型：</h2></td><td>${oData.categoryName}</td></tr>
                    <tr><td><h2>所属部门：</h2></td><td>${oData.orgName}</td></tr>
                    <tr><td><h2>共享模式：</h2></td><td>${oData.shareModeName}</td></tr>
                    <tr><td><h2>位置：</h2></td><td>${oData.position}</td></tr>
                    <tr><td><h2>备注：</h2></td><td>${oData.remark}</td></tr>
                  </table>
                </div>`;
      return winInfo;
    },
    getWinInfo_vehicle(oData) {
      oData.temperature1 = oData.temperature1 ? oData.temperature1 : "";
      oData.temperature2 = oData.temperature2 ? oData.temperature2 : "";
      oData.temperature3 = oData.temperature3 ? oData.temperature3 : "";
      oData.temperature4 = oData.temperature4 ? oData.temperature4 : "";
      oData.humidity1 = oData.humidity1 ? oData.humidity1 : "";
      oData.humidity2 = oData.humidity2 ? oData.humidity2 : "";
      oData.humidity3 = oData.humidity3 ? oData.humidity3 : "";
      oData.humidity4 = oData.humidity4 ? oData.humidity4 : "";
      let winInfo = `<div class='win-table'>
                      <table>
                        <tr><td><h2>仓库名称：</h2></td><td>${oData.storageName}</td></tr>
                        <tr><td><h2>区位名称：</h2></td><td>${oData.storageAreaName}</td></tr>
                        <tr><td><h2>仓库类型：</h2></td><td>${oData.storageMoldName}</td></tr>
                        <tr><td><h2>所属企业：</h2></td><td>${oData.comparyName}</td></tr>
                        <tr><td><h2>采集时间：</h2></td><td>${oData.gpsTime}</td></tr>
                        <tr><td><h2>位置：</h2></td><td>${oData.position}</td></tr>
                        <tr><td><h2>经度：</h2></td><td>${oData.lon}</td></tr>
                        <tr><td><h2>纬度：</h2></td><td>${oData.lat}</td></tr>
                        <tr><td><h2>报警状态：</h2></td><td>${oData.alarmStatus}</td></tr>
                        <tr><td><h2>温度1~4：</h2></td><td>${oData.temperature1} ℃ ;${oData.temperature2} ℃ ;${oData.temperature3} ℃ ;${oData.temperature4} ℃ </td></tr>
                        <tr><td><h2>湿度1~4：</h2></td><td>${oData.humidity1} %RH ;${oData.humidity2} %RH ;${oData.humidity3} %RH ;${oData.humidity4} %RH </td></tr>
                      </table>
                    </div>`;
      return winInfo;
    },
    // 智能搜索
    intelligentSearch(sTxt) {
      let aResult_vehicle = [];
      let aResult_marker = [];
      let aResult_area = [];
      let result = {};

      // marker
      this.markerDatas.forEach(item => {
        if (item.areaName.toString().indexOf(sTxt) >= 0) {
          aResult_marker.push({
            id: item.areaId,
            name: item.areaName,
            lng84: item.lonCenter,
            lat84: item.latCenter,
            address: item.position,
            winInfo: this.getWinInfo_marker(item)
          });
        }
      });
      if (aResult_marker.length > 0) {
        result["marker"] = {
          title: "点",
          datas: aResult_marker
        };
      }
      // area
      this.areaDatas.forEach(item => {
        if (item.areaName.toString().indexOf(sTxt) >= 0) {
          aResult_area.push({
            id: item.areaId,
            name: item.areaName,
            lng84: item.lonCenter,
            lat84: item.latCenter,
            address: item.position,
            winInfo: this.getWinInfo_area(item)
          });
        }
      });
      if (aResult_area.length > 0) {
        result["area"] = {
          title: "区域",
          datas: aResult_area
        };
      }

      // vehicle
      request
        .fetchIntelligentVehicles_Api({ vehicleNo: sTxt })
        .then(res => {
          if (res.code == 1 && res.result) {
            res.result.forEach(item => {
              aResult_vehicle.push({
                name: item.vehicleNo,
                id: item.vehicleId,
                lng84: item.lon,
                lat84: item.lat,
                address: item.position + item.placeName + item.roadName,
                winInfo: this.getWinInfo_vehicle(item)
              });
            });
            if (aResult_vehicle.length > 0) {
              result["vehicle"] = {
                title: "车辆",
                datas: aResult_vehicle
              };
            }
          }
          // 处理返回结果
          this.$refs[this.mapName].searchBack_intelligent(result);
        })
        .catch(() => {
          // 处理返回结果
          this.$refs[this.mapName].searchBack_intelligent(result);
        });
    },

    // 拉框查找自己车
    // type: 1 - 找自己的车；2 - 找已经定位的车
    // maxMin: { sw: { lng, lat }, ne: { lng, lat }} 此经纬度是84经纬度
    // pullRectSearch({ type = 0, maxMin }) {
    //   switch (type) {
    //     case 1:
    //       request
    //         .fetchMyVehiclesByPullRect_Api({
    //           minLon: maxMin.sw.lng,
    //           maxLon: maxMin.ne.lng,
    //           minLat: maxMin.sw.lat,
    //           maxLat: maxMin.ne.lat
    //         })
    //         .then(res => {
    //           if (res.code == 1 && res.result) {
    //             let datas = [];
    //             datas = res.result.map(item => {
    //               return {
    //                 name: item.vehicleNo,
    //                 id: item.vehicleId,
    //                 lng84: item.lon,
    //                 lat84: item.lat,
    //                 position: item.position,
    //                 gpsStatus: item.gpsStatus,
    //                 alarmStatus: item.alarmStatus,
    //                 gpsTime: item.gpsTime,
    //                 winInfo: this.getWinInfo_vehicle(item)
    //               };
    //             });
    //             // if(!datas || datas.length == 0){
    //             //   this.$message({
    //             //     message: "没有找到相关车辆",
    //             //     type: "warning"
    //             //   });
    //             // }
    //             // else{
    //             this.$refs[this.mapName].pullRectSearchBack({ type, datas });
    //             // }
    //           }
    //         });
    //       break;
    //     case 2:
    //       break;
    //     default:
    //       break;
    //   }
    // },
    // 导出 excel
    exportExcel_pullRect(opts) {
      request.exportPullRect_Api({ vehicleIdList: opts.aIds });
    },
    // 全屏
    fullScreen() {
      this.updateFullScreen();
    }
    // 拉去点, 线, 区域叠加信息?
    // fetchOverlaySetting() {
    //     request.fetchOverlaySetting_Api().then(res => {
    //         if (res.code == 1) {
    //             // lavel
    //             let aLevel = res.result.markerAreaLevel
    //                 ? res.result.markerAreaLevel.split(",")
    //                 : [];
    //             if (aLevel[0]) {
    //                 this.mLevel = aLevel[0];
    //             }
    //             if (aLevel[1]) {
    //                 this.aLevel = aLevel[1];
    //             }
    //             // show / hide
    //             if (res.result.mapObjShow) {
    //                 if (res.result.mapObjShow & 1) {
    //                     this.mEyeShow = true;
    //                 } else {
    //                     this.mEyeShow = false;
    //                 }
    //                 if (res.result.mapObjShow & 2) {
    //                     this.aEyeShow = true;
    //                 } else {
    //                     this.aEyeShow = false;
    //                 }
    //                 if (res.result.mapObjShow & 4) {
    //                     this.lEyeShow = true;
    //                 } else {
    //                     this.lEyeShow = false;
    //                 }
    //             }
    //         }
    //     });
    // }
  },
  created() {
    // this.fetchOverlaySetting();
    // this.fetchCategoryDatasAct();
  }
};
export { mixin };
